import React from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { BaseCell } from '../../../../../components/TableCells/BaseCell';
import { LinkButton } from '../../../RevisaoPrecos/Components/LinkButton';
import { CLEAR_FIELDS_TOOLTIP } from '../../pages/PrecoAtacado/constants';
import { Wholesale } from '../../pages/PrecoAtacado/types';
import styles from './ClearFieldsCell.module.scss';

const { MainContainer } = BaseCell;

export type ClearFieldsCellProps = {
  rowData: Wholesale.RowData;
  onClear: (rowData: Wholesale.RowData) => void;
};

const ClearFieldsCell = ({ rowData, onClear }: ClearFieldsCellProps) => {
  const hasLastUpdate = !!rowData.lastEditedBy || !!rowData.lastEditedDate;

  if (!hasLastUpdate) return null;

  return (
    <BaseCell className={styles.cell}>
      <MainContainer className={styles['main-container']}>
        <Whisper trigger="hover" placement="left" speaker={<Tooltip className={styles.tooltip}>{CLEAR_FIELDS_TOOLTIP}</Tooltip>}>
          <LinkButton
            className={styles['clear-button']}
            onClick={() => {
              onClear(rowData);
            }}
          >
            Limpar campos
          </LinkButton>
        </Whisper>
      </MainContainer>
    </BaseCell>
  );
};

export default ClearFieldsCell;
